module.exports = __webpack_public_path__ + "static/img/pinpai-3.b8d9b6dc.png";